import cloneDeep from 'lodash.clonedeep';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { initVehicleConfiguration } from '../server/data/defaults';
import { setVehicleConfiguration } from '../actions/setVehicleConfiguration';

const NavButtons = ({
	rootPath,
	currentStepObj,
	nextStepLink,
	prevStepLink
}) => {
	const labels = useLabels();
	const { widgetName, windowId } = useRequestData();
	const dispatch = useDispatch();
	const { enableContinueBtn } = useSelector((state) => state);
	const {
		vehicleConfiguration: { trimName, options }
	} = useSelector((state) => state);

	const continueBtnDisabledClass = enableContinueBtn ? '' : 'disabled';
	const styles = [
		'btn-block',
		'btn',
		'btn-primary',
		'my-5',
		continueBtnDisabledClass
	];

	const { name: currentStep, showContinue, showBack } = currentStepObj;

	const continueLabel = labels.get('CONTINUE');
	const submitTrackingEvent = (btn) => {
		let option = null;
		let packagesSelected = null;
		switch (currentStep) {
			case 'trim':
				option = trimName;
				break;
			case 'configuration':
				if (options.cab) {
					option = `${options.drivetrain.value} ${options.cab.value}`;
				} else {
					option = options.drivetrain.value;
				}
				break;
			case 'color':
				option = options.paint.value;
				break;
			case 'packages':
				packagesSelected = options.packages.selections.map(
					(item) => item.description
				);
				option = packagesSelected.join(', ');
				break;
			default:
				break;
		}
		switch (btn) {
			case 'continue':
				if (option !== null) {
					trackEvent(widgetName, windowId, {
						element: `${currentStep} option selected`,
						elementCTA: `${option} in this ${currentStep} step selected`,
						action: 'clicked',
						result: 'Continued to next step'
					});
				}
				break;
			case 'back':
				trackEvent(widgetName, windowId, {
					element: `${currentStep} Go Back`,
					elementCTA: `${currentStep} step user is on`,
					action: 'clicked',
					result: 'Back to previous step'
				});
				break;
			case 'startOver':
				trackEvent(widgetName, windowId, {
					element: `${currentStep} Start Over`,
					elementCTA: `${currentStep} step user is on`,
					action: 'clicked',
					result: 'New Vehicle request form reset'
				});
				break;
			default:
				break;
		}
	};

	const buttonProps = {
		className: styles.join(' '),
		id: 'wcc-continue',
		to: nextStepLink,
		onClick: () => submitTrackingEvent('continue')
	};

	const handleStartOver = () => {
		dispatch(setVehicleConfiguration(cloneDeep(initVehicleConfiguration)));
		submitTrackingEvent('startOver');
	};

	return (
		<React.Fragment>
			<div className="px-3">
				{showContinue && <Link {...buttonProps}>{continueLabel}</Link>}
			</div>

			{showBack && (
				<div className="mb-3">
					<Link
						className="btn-link ddc-font-size-small text-muted text-decoration-underline"
						to={prevStepLink}
						onClick={() => submitTrackingEvent('back')}
					>
						{labels.get('GO_BACK')}
					</Link>
					<div className="d-inline-block" style={{ width: '24px' }}>
						{' '}
					</div>
					<Link
						className="btn-link ddc-font-size-small text-muted text-decoration-underline"
						onClick={handleStartOver}
						to={rootPath}
					>
						{labels.get('START_OVER_CAPITALIZED')}
					</Link>
				</div>
			)}
		</React.Fragment>
	);
};

NavButtons.propTypes = {
	rootPath: PropTypes.string.isRequired,
	currentStepObj: PropTypes.shape({
		name: PropTypes.string.isRequired,
		showContinue: PropTypes.bool.isRequired,
		showBack: PropTypes.bool.isRequired
	}).isRequired,
	nextStepLink: PropTypes.string.isRequired,
	prevStepLink: PropTypes.string.isRequired
};

export default NavButtons;
